// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2WQXP","cell":"ColumnAccessor_cell__1YUNH","firstCellAccent":"ColumnAccessor_firstCellAccent__3GlhZ"};